export enum InterpretationIconType {
  alertNothingToReport = "alertNothingToReport",
  alertRedFlagAlert = "alertRedFlagAlert",
  sentiment = "sentiment",
  topicInsight = "topicInsight",
  recommendation = "recommendation",
  comment = "comment",
}
